/**
 * Showcase product card: color swatches, price sync, AJAX add to cart.
 * After success, publishes PUB_SUB_EVENTS.cartUpdate with source "product-form"
 * so assets/custom-drawer-cart.js refreshes and opens the custom cart drawer.
 */
(function () {
  const ROOT = '[data-product-card-showcase]';

  function parseVariantsScript(root) {
    const el = root.querySelector('[data-pc-variants-json]');
    if (!el || !el.textContent) return [];
    try {
      const data = JSON.parse(el.textContent);
      return Array.isArray(data) ? data : [];
    } catch {
      return [];
    }
  }

  function formatMoney(cents, templateEl) {
    const c = Number(cents);
    if (!Number.isFinite(c)) return '';
    const t = templateEl && templateEl.textContent ? templateEl.textContent.trim() : '{{amount}}';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(c, t);
      } catch {
        /* fall through */
      }
    }
    const amount = (c / 100).toFixed(2);
    return t.replace(/\{\{\s*amount\s*\}\}/i, amount).replace(/\[amount\]/i, amount);
  }

  function findVariantForColor(variants, colorIndex, colorValue, otherSelections) {
    const others = otherSelections || {};
    const cv = String(colorValue == null ? '' : colorValue).trim();
    return variants.find(function (v) {
      if (!v || !Array.isArray(v.options)) return false;
      const opt = v.options[colorIndex];
      if (String(opt == null ? '' : opt).trim() !== cv) return false;
      for (const key in others) {
        const idx = parseInt(key, 10);
        const a = String(v.options[idx] == null ? '' : v.options[idx]).trim();
        const b = String(others[key] == null ? '' : others[key]).trim();
        if (a !== b) return false;
      }
      return true;
    });
  }

  function firstAvailableVariant(variants) {
    return variants.find(function (v) {
      return v && v.available;
    });
  }

  function postAddToCart(variantId, quantity) {
    const url = window.routes && window.routes.cart_add_url;
    if (!url) return Promise.reject(new Error('Cart URL missing'));

    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    };

    const body = JSON.stringify({
      items: [{ id: Number(variantId), quantity: quantity || 1 }],
    });

    return fetch(url, { method: 'POST', headers: headers, body: body, credentials: 'same-origin' }).then(function (
      res
    ) {
      return res.json().then(function (json) {
        if (!res.ok) {
          const msg = json && (json.description || json.message || json.error);
          throw new Error(msg || 'Add to cart failed');
        }
        return json;
      });
    });
  }

  function publishCartUpdate(cartData, variantId) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'product-form',
      productVariantId: String(variantId),
      cartData: cartData,
    });
  }

  function optionValueFromButton(btn) {
    if (!btn || !btn.getAttribute) return '';
    return String(btn.getAttribute('data-option-value') || '').trim();
  }

  function setSwatchSelection(fieldset, value) {
    const want = String(value == null ? '' : value).trim();
    fieldset.querySelectorAll('.pc-showcase__swatch').forEach(function (btn) {
      const raw = optionValueFromButton(btn);
      const on = raw === want;
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  function updateUi(root, variant, templateEl, colorLabel) {
    const priceEl = root.querySelector('[data-pc-price]');
    const compareEl = root.querySelector('[data-pc-compare]');
    const atc = root.querySelector('[data-pc-atc]');
    const err = root.querySelector('[data-pc-error]');
    const img = root.querySelector('[data-pc-product-img]');
    const subColor = root.querySelector('[data-pc-subtitle-color]');

    if (err) err.textContent = '';

    if (img && variant && variant.featured_image) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.src = variant.featured_image;
      if (variant.featured_image_alt) {
        img.alt = String(variant.featured_image_alt);
      }
      img.hidden = false;
      img.classList.remove('pc-showcase__img--pending');
    }

    if (subColor != null && colorLabel != null && String(colorLabel).length) {
      subColor.textContent = String(colorLabel).toUpperCase();
    }

    if (priceEl && variant) priceEl.textContent = formatMoney(variant.price, templateEl);

    if (compareEl) {
      if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price, templateEl);
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }

    if (atc && variant) {
      atc.disabled = !variant.available;
      const sold = atc.dataset.labelSoldOut || 'Sold out';
      const unavail = atc.dataset.labelUnavailable || 'Unavailable';
      const add = atc.dataset.labelAdd || 'Add to cart';
      if (!variant.available) {
        atc.textContent = variant.available === false && variant.price != null ? sold : unavail;
      } else {
        atc.textContent = add;
      }
    }

    root.dataset.variantId = variant && variant.id ? String(variant.id) : '';
  }

  function readCardConfig(root) {
    const colorIndexStr = root.dataset.colorOptionIndex || '';
    const colorIndex = colorIndexStr === '' ? -1 : parseInt(colorIndexStr, 10);
    const templateEl = root.querySelector('[data-pc-money-template]');
    const otherJson = root.querySelector('[data-pc-other-options-json]');
    let otherSelections = {};
    if (otherJson && otherJson.textContent) {
      try {
        otherSelections = JSON.parse(otherJson.textContent) || {};
      } catch {
        otherSelections = {};
      }
    }
    const variants = parseVariantsScript(root);
    return { colorIndex, templateEl, otherSelections, variants };
  }

  function resolveVariantForColorValue(variants, colorIndex, colorValue, otherSelections) {
    if (colorIndex < 0) return variants[0] || null;
    let v = findVariantForColor(variants, colorIndex, colorValue, otherSelections);
    if (!v) v = findVariantForColor(variants, colorIndex, colorValue, {});
    if (!v) v = firstAvailableVariant(variants);
    return v || null;
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.pc-showcase__swatch');
    if (!btn || btn.disabled) return;
    const root = btn.closest(ROOT);
    if (!root) return;
    const fieldset = root.querySelector('.pc-showcase__swatches');
    if (!fieldset || !fieldset.contains(btn)) return;

    const cfg = readCardConfig(root);
    if (cfg.colorIndex < 0) return;

    const val = optionValueFromButton(btn);
    if (!val) return;
    const variant = resolveVariantForColorValue(cfg.variants, cfg.colorIndex, val, cfg.otherSelections);
    if (!variant) return;
    setSwatchSelection(fieldset, val);
    updateUi(root, variant, cfg.templateEl, val);
  });

  function initRoot(root) {
    if (root.dataset.pcInit === '1') return;
    root.dataset.pcInit = '1';

    const variants = parseVariantsScript(root);
    const atc = root.querySelector('[data-pc-atc]');

    function currentVariant() {
      const id = root.dataset.variantId;
      if (!id) return null;
      return variants.find(function (v) {
        return String(v.id) === String(id);
      });
    }

    if (atc) {
      atc.addEventListener('click', function () {
        const err = root.querySelector('[data-pc-error]');
        const variant = currentVariant() || firstAvailableVariant(variants);
        if (err) err.textContent = '';
        if (!variant || !variant.id) {
          if (err) err.textContent = atc.dataset.errorPick || 'Choose an option.';
          return;
        }
        if (!variant.available) return;

        atc.classList.add('is-loading');
        atc.disabled = true;

        postAddToCart(variant.id, 1)
          .then(function (cartData) {
            publishCartUpdate(cartData, variant.id);
          })
          .catch(function (e) {
            if (err) err.textContent = e.message || 'Could not add to cart.';
          })
          .finally(function () {
            atc.classList.remove('is-loading');
            var v = currentVariant() || firstAvailableVariant(variants);
            if (atc && v) atc.disabled = !v.available;
            else if (atc) atc.disabled = false;
          });
      });
    }
  }

  function scan() {
    document.querySelectorAll(ROOT).forEach(initRoot);
  }

  var scanScheduled = false;
  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    requestAnimationFrame(function () {
      scanScheduled = false;
      scan();
    });
  }

  /**
   * product-recommendations (and similar) inject HTML after fetch, past DOMContentLoaded.
   * Without this, cards never get initRoot() and swatches / image updates do nothing.
   */
  function observeNewShowcaseRoots() {
    if (typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(function (mutations) {
      var found = false;
      outer: for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches(ROOT)) {
            found = true;
            break outer;
          }
          if (n.querySelector && n.querySelector(ROOT)) {
            found = true;
            break outer;
          }
        }
      }
      if (found) scheduleScan();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
      observeNewShowcaseRoots();
    });
  } else {
    scan();
    observeNewShowcaseRoots();
  }

  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('product-recommendations:loaded', scheduleScan);
})();
